module.exports = __webpack_public_path__ + "img/lemn_2kl.9abdc493.jpg";